import { computed, getCurrentInstance, ref, watch } from 'vue';
import { convertNumberToCNUnit } from '@/utils/api';

export const useQuarterlyCommon = options => {
	const { proxy } = getCurrentInstance();

	const core_option = computed(() => ({
		roe: 'ROE',
		roa: 'ROA',
		nAssetPs: proxy.$t('enterprise.bvps'),
		nCInCashPs: proxy.$t('enterprise.cfps'),
		grossMargin: proxy.$t('enterprise.gross-margin'),
		eps: proxy.$t('enterprise.eps'),
		assetLiabRatio: proxy.$t('enterprise.current-debt-ration'),
		reserPs: proxy.$t('enterprise.CapSurFdPS'),
		rePs: proxy.$t('enterprise.ups'),
		revPs: proxy.$t('enterprise.operating-income-per-share'),
		arTurnover: proxy.$t('enterprise.accounts-receivable-turnover'),
		invenTurnover: proxy.$t('enterprise.inventory-turnover-ratio'),
		caTurnover: proxy.$t('enterprise.current-assets-turnover'),
		faTurnover: proxy.$t('enterprise.FATR'),
		taTurnover: proxy.$t('enterprise.ATR'),
		revenueYoy: proxy.$t('enterprise.revenue-growth-rate'),
		operProfitYoy: proxy.$t('enterprise.operating-profit-grow-rate'),
		niYoy: proxy.$t('enterprise.net-profit-growth-rate'),
		taYtd: proxy.$t('enterprise.total-assets-growth-rate'),
		currentRatio: proxy.$t('enterprise.current-ratio'),
		quickRatio: proxy.$t('enterprise.quick-ratio'),
		nCfOperAPs: proxy.$t('enterprise.CFPS'),
		tCa: proxy.$t('enterprise.current-assets'),
		tNca: proxy.$t('enterprise.non-current-assets'),
		tCl: proxy.$t('enterprise.current-liabilitise'),
		tNcl: proxy.$t('enterprise.non-current-liabilitise'),
		capitalReser: proxy.$t('enterprise.additional-paid-in-Capital'),
		surplusReser: proxy.$t('enterprise.legal-reserve'),
		retainedEarnings: proxy.$t('enterprise.retained-profit'),
		tShEquity: proxy.$t('enterprise.owners-equity'),
		revenue: proxy.$t('enterprise.total-operating-revenue'),
		operateProfit: proxy.$t('enterprise.operating-profit'),
		tProfit: proxy.$t('enterprise.total-profit'),
		nIncome: proxy.$t('enterprise.net-profit'),
		nIncomeAttrP: proxy.$t('enterprise.net-profit-of-parent-company-owners'),
		nCfOperateA: proxy.$t('enterprise.operating-cash-flow'),
		nCfFrInvestA: proxy.$t('enterprise.investing-cash-flow'),
		nCfFrFinanA: proxy.$t('enterprise.finaning-cash-flow')
	}));

	const getRoadshowStatus = (status) => {
		return proxy.$t(`enterprise.roadshow-status.${status}`);
	}

	const percentCore = [
		'roe',
		'roa',
		'grossMargin',
		'assetLiabRatio',
		'npMargin',
		'arTurnover',
		'invenTurnover',
		'caTurnover',
		'faTurnover',
		'taTurnover',
		'revenueYoy',
		'operProfitYoy',
		'niYoy',
		'taYtd',
		'naYtd',
		'currentRatio',
		'quickRatio'
	];

	const handleCoreValue = (val, key) => {
		if (percentCore.includes(key)) {
			return val.toFixed(2) + '%';
		} else {
			const { value, unit } = convertNumberToCNUnit(val);
			return unit ? `${value}<span style="font-size:13px; ">${unit}</span>` : value;
		}
	};

	// 季度数据管理
	const quarterListDetails = ref({});
	const activeYear = ref(options?.value?.performanceYear || '');
	const activeQuarter = ref(options?.value?.quarter || '');

	//如果传入了props，则监听props变化
	if (options) {
		watch(
			() => options.value,
			newVal => {
				console.log('😪 # watch # year:', newVal);
				activeYear.value = newVal.performanceYear;
				activeQuarter.value = newVal.quarter;
			},
			{
				immediate: true,
				deep: true
			}
		);
	}

	// 计算当前季度详情
	const quarterDetails = computed(() => {
		let obj = {};
		const keys = Object.keys(core_option.value).map(key => key);
		let target =
			(quarterListDetails.value?.[activeYear.value] || []).find(item => item.quarter == activeQuarter.value) ||
			{};
		keys.forEach(key => {
			if (Object.prototype.hasOwnProperty.call(target.coreIndicators || {}, key)) {
				obj[key] = target?.coreIndicators?.[key];
			}
		});
		target.coreIndicators = obj;
		return target;
	});

	// 刷新核心数据方法
	const coreRefresh = result => {
		quarterListDetails.value = result;
		let target;
		Object.values(result).forEach(item => {
			if (item.find(k => k.isTop)) target = item.find(k => k.isTop);
		});
		activeYear.value = target ? target.performanceYear : Object.keys(result).reverse()?.[0];
		activeQuarter.value = target ? target.quarter : result[activeYear.value]?.[0]?.quarter;
	};

	return {
		core_option,
		percentCore,
		getRoadshowStatus,

		handleCoreValue,
		quarterListDetails,
		activeYear,
		activeQuarter,
		quarterDetails,
		coreRefresh
	};
};
